module.exports = __webpack_public_path__ + "static/img/Industry_data.88f3715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/Industry_data.png
// module id = 9qYi
// module chunks = 44